<template>
	<div class="contentPage">
		<main-table-all-back
				v-if="managerStatementsList"
				textCreate="generate"
				flag="managerStatements"
				page-title="Manager statements"
				:headers="headers"
				:settings="getSettings"
				:filtersList="managerStatementsFilters"
				:list="managerStatementsList"
				:defaultOrder="managerStatementsOrder"
				:defaultSort="managerStatementsSort"

				:totals="managerStatementsTotals"
				:total-pages="managerStatementsTotal"
				:limit-pages="managerStatementsLimit"
				:pages="[ 15, 50, 100, 200, 500, 'All' ]"
				:uniqId="uniqId"
				@updateSettings="onSettingsOpen"
				@updateEvent="onEvent"
				@updateClickButton="onClickButton"
				@updateList="onList"
				@updateRefreshFilters="onUpdateFilters(defaultFilter)"
				@updateExport="onExport"
				isExport
				is-create
				is-settings
		></main-table-all-back>

		<manager-statements-form
				v-if="isManagerStatementsForm"
				:isEdit="isEdit"
				:managerStatementsItem="managerStatementsItem"
				:managerStatementsMonth="managerStatementsMonth"
				:managerStatementsDepartments="managerStatementsDepartments"
				@updateCloseDialog="onCloseDialog"
		></manager-statements-form>

		<dialog-remove
				v-if="isDialogRemove"
				:titleRemove="titleRemove"
				:textRemove="textRemove"
				@updateRemove="onRemove"
				@updateCloseRemove="onCloseRemove"
		></dialog-remove>
	</div>
</template>

<script>
/* eslint-disable */
// vuex
import { mapActions, mapGetters } from "vuex";
// components
import MainTableAllBack from "@/shared/MainTableAllBack/MainTableAllBack.vue";
import ManagerStatementsForm
	from "@/components/Accounting/ManagerStatements/ManagerStatementsForm/ManagerStatementsForm.vue";
// mixins
import settingsMixins from "@/mixins/settingsMixins";
import { PERMISSIONS } from "@/constants/constants";
import DialogRemove from "@/shared/DialogRemove/DialogRemove.vue";
import { TITLE } from "@/pages/Settings/UserAccountSettings/constants";


export default {
	name: "ManagerStatements",
	components: { DialogRemove, MainTableAllBack, ManagerStatementsForm },
	mixins: [ settingsMixins ],
	computed: mapGetters([
		"managerStatementsList",
		"managerStatementsFilters",
		"managerStatementsTotals",
		"managerStatementsOrder",
		"managerStatementsLimit",
		"managerStatementsSort",
		"managerStatementsTotal",
		"managerStatementsMonth",
		"managerStatementsDepartments",
		"managerStatementsItem",
		"permissions",
	]),
	data: () => ({
		isManagerStatementsForm: false,
		defaultFilter: null,
		activeTableFilters: null,
		managerId: null,
		isEdit: false,

		isDialogRemove: false,
		titleRemove: null,
		textRemove: null,
		activeItem: null,
		nameComponent: null,
	}),
	methods: {
		...mapActions([
				'getManagerStatements',
				'getManagerStatementsFilters',
				'actionPreloader',
				'onExportLink',
				'onManagerStatementsRemoveItem',
				'getManagerStatementsCreate',
				'onManagerStatementsView',
				'onClearManagerStatements',
		]),
		async onCloseDialog(value) {
			if (value) await this.onUpdateFilters();
			this.isManagerStatementsForm = false;
			this.onClearManagerStatements();
		},

		async onEvent(flag) {
			if (flag === 'create') {
				this.isManagerStatementsForm = true;
				this.isEdit = false;
			}
		},
		async onUpdateFilters(filters, isWithoutFilters) {
			await this.getManagerStatements(filters);
			if (!isWithoutFilters) await this.getManagerStatementsFilters(filters);
		},
		async onList(values) {
			const { value, flag } = values;
			// сохраняем выбранные фильтры отдельно
			this.activeTableFilters = value;

			switch (flag) {
				case "sorting":
					await this.getManagerStatements(value);
					break;
				case "page":
					await this.onUpdateFilters(value, true);
					break;
				default:
					await this.onUpdateFilters(value);
			}
		},
		async onExport(values) {
			await this.onExportLink({ values, requestKey: 'trucks' });
		},
		async onClickButton({ key, item }) {
			this.activeItem = item;

			if (key === 'view') {
				this.actionPreloader(true);
				await this.onManagerStatementsView(item.id);
				this.isEdit = true;
				this.isManagerStatementsForm = true;
				this.actionPreloader(false);
			}

			if (key === "delete") {
				const { bonus, month } = item;
				const title = TITLE.REMOVE_STATEMENTS;
				const text = `📋 The manager statement of <b>${ bonus }</b> 💰 for <b>${ month }</b> 📅.`;
				this.onRemoveDialog({ title, text });
			}
		},
		async onRemove() {
			this.isPreloader = true;
			await this.onManagerStatementsRemoveItem(this.activeItem);
			this.onCloseRemove();
			await this.onUpdateFilters(this.defaultFilter);
			this.isPreloader = false;
		},

		onRemoveDialog(args) {
			const { title, text } = args;
			this.titleRemove = title;
			this.textRemove = text;
			this.isDialogRemove = true;
		},

		onCloseRemove() {
			this.isDialogRemove = false;
		},
	},
	async mounted() {
		await this.onUpdateFilters();
	}
};
</script>

<style scoped lang="scss">

</style>
